import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3tsns4s75m: FaireBrandEntity = {
  token: "b_3tsns4s75m",
  type: "brand",
  name: "MOTO",
  avatarUrl:
    "https://cdn.faire.com/fastly/c74f80eb3cc3e71818ccb5de52f4e9270748666d669107a4dc4e151c4cd473d3.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b2f9524d63245792964b112215f51e0ae0276c1aca1361374cf1952d93d2400e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c74f80eb3cc3e71818ccb5de52f4e9270748666d669107a4dc4e151c4cd473d3.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b2f9524d63245792964b112215f51e0ae0276c1aca1361374cf1952d93d2400e.jpeg",
  location: "San Francisco, CA, USA",
  minimumOrderDollars: 40,
  rating: 5,
  reviewCount: 9,
  isInsider: true,
  description:
    "I first had the idea of an Italian squeeze-bottle hot sauce after being banned from buying Calabrian chilis because I had stained multiple dining room tablecloths.\n\nWhy was this unique flavor bomb drowned in oil and trapped in a messy little jar? Why did I have to spoon it out and destroy everything on the way to my plate? Why isn't there a hot sauce that compliments pizza, America's favorite food? \n\nMOTO brings the iconic Italian heat of Calabrian chilis in an easy, no-mess squeeze bottle. Fire up pizza, pasta, panini, protein, and veg!",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:19:23.728Z",
    importedBy: "entity-db-cli",
  },
};
